import WarpElement from '@warp-ds/elements-core';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { trackGoToItem } from '../utils/pulseTrackingUtils.js';
import '@warp-ds/icons/elements/link-external-16';
import '@warp-ds/elements/components/button';

@customElement('external-item-link')
export class ExternalItemLink extends WarpElement {
	@property({ type: String }) orgName!: string;
	@property({ type: Object }) externalItemLink?: { uri: string; text: string };
	@property({ type: String }) variant?: 'primary' | 'secondary' = 'secondary';

	static styles = [
		...WarpElement.styles,
		css`
			@css-placeholder-AQ4deW;
		`,
	];

	render() {
		if (!this.externalItemLink) {
			return nothing;
		}
		return html`
			<w-button
				href=${this.externalItemLink.uri}
				variant=${this.variant}
				@click="${() => {
					trackGoToItem(this.orgName!, this.externalItemLink?.uri);
				}}"
				full-width
				target="_blank"
			>
				<div class="flex gap-4 justify-center items-center">
					<span>${this.externalItemLink.text}</span>
					<span class="sr-only">,</span>
					<w-icon-link-external-16 class="flex"></w-icon-link-external-16>
				</div>
			</w-button>
		`;
	}
}
